import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'shared/store/store'

type GuidesUiState = {
  /** Guide ids temporarily treated as not-completed (client-side, like the old GUIDES_RETAKE) */
  retakeIds: string[]
}

const initialState: GuidesUiState = {
  retakeIds: [],
}

const guidesUiSlice = createSlice({
  name: 'guidesUi',
  initialState,
  reducers: {
    retakeGuides: (state, action: PayloadAction<string[]>) => {
      state.retakeIds = action.payload
    },
    clearRetake: () => initialState,
  },
})

export const { retakeGuides, clearRetake } = guidesUiSlice.actions
export const getGuidesUi = (state: RootState) => state.guidesUi
export default guidesUiSlice.reducer
